module.exports = __webpack_public_path__ + "img/yishi3.994f4c41.jpg";